module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new/0016.jpg?v=dc662cc7";